import {
  Box,
  FormControlLabel,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { AdvancedFiltersDialog } from "./AdvancedFiltersDialog";

import { useHistoryStore } from "../historyStore";

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(2),
  padding: theme.spacing(1.5),
  alignItems: "flex-end",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    "& > label": {
      order: 2,
    },
  },
}));

export function HistorySettings() {
  const { t } = useTranslation();

  const interval = useHistoryStore((s) => s.intervalSize);
  const setInterval = useHistoryStore((s) => s.setIntervalSize);

  const onlyNights = useHistoryStore((s) => s.onlyNights);
  const setOnlyNights = useHistoryStore((s) => s.setOnlyNights);

  return (
    <Wrapper sx={{ displayPrint: "none" }}>
      <Box>
        <Typography sx={{ paddingBottom: 1.5 }}>
          {t("Choose time unit")}
        </Typography>
        <ToggleButtonGroup
          onChange={(_, value) => setInterval(value)}
          exclusive
          value={interval}
        >
          <ToggleButton value={"weeks"}>{t("Week")}</ToggleButton>
          <ToggleButton value={"months"}>{t("Month")}</ToggleButton>
          <ToggleButton value={"quarters"}>{t("Quarter")}</ToggleButton>
          <ToggleButton value={"years"}>{t("Year")}</ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <FormControlLabel
        sx={{ margin: 1, gap: 1 }}
        control={
          <Switch checked={onlyNights} onChange={(_, v) => setOnlyNights(v)} />
        }
        label={t("Only night sessions")}
      />
      <Box sx={{ display: "flex", flexGrow: 1, justifyContent: "flex-end" }}>
        <AdvancedFiltersDialog />
      </Box>
    </Wrapper>
  );
}
